import { CrossIcon, toaster } from "evergreen-ui";
import React, { useCallback, useEffect, useState } from "react";
import imageCompression from "browser-image-compression";
import { storage } from "firebase";

interface IProps {
  file: any;
  removeFile?: any;
  index: number;
  onComplete: any;
}
const FileUploading: React.FC<IProps> = ({
  file,
  removeFile,
  onComplete,
  index,
}) => {
  const [progress, setProgress] = useState<number | null>(null);

  const uploadFile = useCallback(async (): Promise<any> => {
    let fileToUpload = file;
    if (file.type.split("/")[0] === "image") {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      fileToUpload = await imageCompression(file, options);
    }
    let storageRef = storage().ref();
    let now = new Date();
    let imgRef = storageRef.child(
      "gallery/" +
        Math.random().toString(36).substr(2, 5) +
        "_" +
        now.toString() +
        "/" +
        file.name
    );
    var metadata = {
      contentType: file.type,
    };
    let puttingImg = imgRef.put(fileToUpload, metadata);

    puttingImg.on(
      "state_changed",
      (snapshot) => {
        setProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      },
      (error) => {
        toaster.danger(error.message);
      },
      () => {
        puttingImg.snapshot.ref.getDownloadURL().then((downloadUrl) => {
          onComplete(downloadUrl, index, fileToUpload);
        });
      }
    );
    setProgress(4);
  }, [file, index, onComplete]);
  useEffect(() => {
    try {
      if (progress === null) {
        setProgress(0);
        uploadFile();
      }
    } catch (error) {
      toaster.danger(error?.message);
    }
  }, [progress, uploadFile]);

  return (
    <div className=" flex w-full flex-row p-2 justify-between">
      <p className=" flex flex-auto">{file.name}</p>
      <div className=" flex flex-auto justify-end items-center">
        <div className={` w-32 rounded-lg h-3 bg-gray-100 overflow-hidden`}>
          <div
            className={` bg-${
              progress === 100 ? "green" : "blue"
            }-500 h-full transition-all ease-out duration-1000 max-w-full`}
            style={{ width: `${progress}%` }}
          />
        </div>
        <div
          onClick={() => {
            removeFile(file);
          }}
          className=" cursor-pointer hover:opacity-70 ml-3"
        >
          <CrossIcon size={12} />
        </div>
      </div>
    </div>
  );
};

export default FileUploading;
